require('./payrollLoanRequestRejected.scss');

// @vendor
const React = require('react');
// @components
const WizardError = require('components/commons/wizardError/wizardError');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

const PayrollLoanRequestRejected = () => {
    const errorTitle = formatText('payrollLoanRequestRejected-title');
    const mainButtonLabel = formatText('payrollLoanRequestRejected-backTo').toUpperCase();
    const mainButtonConfig = {
        label: mainButtonLabel,
        url: '/myprofile/global'
    };

    return (
        <section className="col-xs-12 payroll-loan-request-rejected">
            <WizardError
                errorMessage={errorTitle}
                mainButton={mainButtonConfig}
            >
                <div className="payroll-loan-request-rejected__content">
                    <FormattedText value="payrollLoanRequestRejected-message" />
                </div>
            </WizardError>
        </section>
    );
};

module.exports = PayrollLoanRequestRejected;
